import { ReactComponent as SvgClose } from '@img/icons/close.svg';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './FilterDesktop.styles';
import xor from 'lodash/xor';
const Filter = ({ item, value, onChange, active, toggle }) => {
    return (React.createElement(S.Item, { initial: "closed", animate: active ? 'opened' : 'closed', "aria-expanded": active },
        React.createElement(S.ItemTitle, { onClick: (event) => {
                event.preventDefault();
                toggle();
            } },
            React.createElement("span", null, item.title),
            React.createElement(S.ItemArrow, null,
                React.createElement(S.ItemIcon, null))),
        !!item.options.length && (React.createElement(S.OptionOverlay, { variants: {
                closed: {
                    opacity: 0,
                    transitionEnd: {
                        display: 'none',
                    },
                },
                opened: {
                    display: 'block',
                    opacity: 1,
                },
            }, transition: {
                duration: 0.15,
                ease: 'easeOut',
            } },
            React.createElement(S.OptionList, null, item.options.map((option) => {
                const id = `${item.name}-${option.value}`;
                const selectedOptions = value[item.name] ?? [];
                return (React.createElement(S.Option, { key: option.value },
                    React.createElement(S.OptionInput, { id: id, checked: selectedOptions.includes(option.value), name: item.name, type: "checkbox", value: option.value, onChange: () => {
                            onChange(item.name, option.value);
                        } }),
                    React.createElement(S.OptionLabel, { htmlFor: id }, option.text)));
            }))))));
};
const FilterDesktop = ({ cta, items, showReset = true, title, value, onChange, onReset, }) => {
    const [activeFilters, setActiveFilters] = React.useState(items ? items.map((x) => x.name) : []);
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(S.FilterTop, null,
                React.createElement(S.Title, null, title),
                showReset && (React.createElement(S.ResetButton, { type: "button", onClick: (event) => {
                        event.preventDefault();
                        onReset && onReset();
                    } }, "Clear all")),
                React.createElement(S.SelectedFilters, null, items
                    ? items.map((item) => (React.createElement(React.Fragment, null, item.options.map((option) => {
                        const selectedOptions = value[item.name] ?? [];
                        return (React.createElement(React.Fragment, null, selectedOptions.includes(option.value) && (React.createElement(S.SelectedFilterBtn, { type: "button", key: option.value, onClick: () => onChange(item.name, option.value) },
                            option.text,
                            " ",
                            React.createElement(SvgClose, null)))));
                    }))))
                    : null)),
            React.createElement(S.ItemList, null,
                items
                    ? items.map((item) => (React.createElement(Filter, { key: item.name, value: value, item: item, onChange: onChange, active: activeFilters.includes(item.name), toggle: () => setActiveFilters(xor([...activeFilters], [item.name])) })))
                    : null,
                cta && (React.createElement(LinkButton, { branding: "primary", title: cta.title, href: cta.url, target: cta.target }))))));
};
export default FilterDesktop;
